export default __webpack_public_path__ + "static/media/34b73904948cc63cebd3111c412604881581618556596.3c8ff8fd.webp";